"use client";

import { Button } from "@/components/ui/button";
import { useScopedI18n } from "@/messages/client";
import { Mail } from "lucide-react";
import * as Nprogress from "nprogress";

export default function SendEmail() {
  const t = useScopedI18n("选型器");

  return (
    <a
      href="mailto:sales@powerquark.com"
      target="_blank"
      onClick={(e) => {
        e.stopPropagation();

        Nprogress.done();
      }}>
      <Button
        className="w-full space-x-2 rounded-md border-primary text-primary"
        variant="outline">
        <Mail size={18} />
        <span>{t("发送电子邮件")}</span>
      </Button>
    </a>
  );
}
